module.exports = __webpack_public_path__ + "static/media/quote_document.20b96f4a.svg";